export default __webpack_public_path__ + "static/media/Coaching.bf81deb4.svg";